import { render, staticRenderFns } from "./ChatbotAgent.vue?vue&type=template&id=21a02ab5&scoped=true"
import script from "./ChatbotAgent.vue?vue&type=script&lang=js"
export * from "./ChatbotAgent.vue?vue&type=script&lang=js"
import style0 from "./ChatbotAgent.vue?vue&type=style&index=0&id=21a02ab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a02ab5",
  null
  
)

export default component.exports